<template>
  <div>
    <div class="two-coloum-inner" v-if="myStatus=='BADGE'">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default"
           @click="moveToDetail(badgeList.boxId,badgeList.missionId)">
        <div
            class="rewardContent pdl-16 pdr-16 d-flex justify-content-center align-items-center flex-column"
        >
          <div class="crownWrapper position-relative d-flex align-items-center flex-column mgb-16">
            <img :src="badgeList.on.resourceUri" alt class="crown100"/>
            <!-- <span
              class="badge-chip bg-dark t-color-white t-body6 d-inline-block pdt-2 pdb-2 pdl-9 pdr-9 position-absolute"
            >X{{badgeList.number}}</span> -->

          </div>
        </div>
        <div class="t-color-title t-body3 mgb-8 t-center font-r h-21">{{ $t(badgeList.name) | charLength }}</div>
        <div class="t-color-gray2 t-helper mgt-0 mgb-0 t-center">
          {{ $moment(badgeList.achievedDate).format('YYYY. MM. DD') }}
        </div>
      </div>

    </div>

    <div class="two-coloum-inner" v-if="myStatus=='AVAILABLE'">
      <div class="header-card mdc-card mdc-elevation--z3 mgb-16 bg-white pda-default">
        <div
            class="rewardContent pdl-16 pdr-16 d-flex justify-content-center align-items-center flex-column"
        >
          <div class="crownWrapper position-relative d-flex align-items-center flex-column mgb-16">
            <img :src="badgeList.on.resourceUri" alt class="crown100 opacity-88"/>
          </div>
        </div>
        <div class="t-color-title t-body3 mgb-8 t-center font-r h-21">{{ $t(badgeList.name) | charLength }}</div>
        <!-- <div class="t-color-gray2 t-helper mgt-0 mgb-0 t-center">2011. 01. 12</div> -->
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 아이템 컴포넌트(my learning main list item component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from "@material/ripple";
import learnApi from "@/api/learnApi.js";

export default {
  props: ["badgeList", "myStatus"],
  data() {
    return {
      learnProgressRate: {},
    };
  },
  filters: {
    charLength(value) {
      if (value.length > 30) {
        return value.substring(0, 30) + ".."
      } else {
        return value
      }

    },
  },
  mounted() {
  },

  computed: {},
  methods: {
    // 학습진행율 데이터 (get learning status data)
    moveToDetail(boxid, missionId) {
      this.$router.push('/badgedetail/' + boxid + '/' + missionId)
    }
  },
};
</script>

<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.crownWrapper {
  max-width: 100px;
  margin-bottom: unset !important;
}

.crown100 {
  max-width: 100px;
}

.badge-chip {
  bottom: 0;
  right: 0;
  border-radius: 12px;
}

.two-column {
  flex-wrap: wrap;
}

.two-column > div {
  flex: 0 0 50%;
}

.two-column .two-coloum-inner {
  flex: 0 0 50%;
}

.opacity-88 {
  opacity: 0.08;
}
</style>